import React from 'react'
import Sponsors from '../topics/partials/Sponsors'

const Section = (props) => {
  const { header } = props

  return (
    <section className='pane clear-pane fat-pane fat-pane-xs'>
      <div className='row center-xs'>
        <div className='col-xs-12'>
          <div className='box'>
            <h2 className='header-32 header-24-sm fat-bottom'>{header}</h2>
          </div>
        </div>
      </div>

      <Sponsors section={props} />
    </section>
  )
}

export default Section
